import React, { useEffect, useState } from 'react'

const SRDetailComponent = () => {
    return <></>
}

export default SRDetailComponent